function splider() {
  initSplide('.js-splide-gallery', {
      type   : 'loop',
      perPage: 3,
      perMove: 1,
      pagination: true,
      arrows: false,
      focus  : 'center',
      gap: 8,
  });
}

function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

document.addEventListener('DOMContentLoaded', splider);